import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import "./Multicheckbox.css";

const CheckboxGroupWeb = ({ options, name, control, parentLabel, mobileAccess }) => {
  console.log("Received Parent Label:", parentLabel);
  
  const isWebAccess = parentLabel === "Web Access";

  // Set the value programmatically when component mounts
  useEffect(() => {
    if (isWebAccess && control._formValues) {
      const viewOption = options.find(option => option.name === "view_permission");
      if (viewOption) {
        // Use control's setValue method
        control._formValues[`${name}.${viewOption.name}`] = true;
        // Or use the form's setValue if available
        if (control._formState && control._formState.isDirty !== undefined) {
          // This means we have access to the form methods
          const formMethods = control._formState;
          if (formMethods.setValue) {
            formMethods.setValue(`${name}.${viewOption.name}`, true);
          }
        }
      }
    }
  }, [isWebAccess, name, options, control]);

  return (
    <div className="checkbox-group-container">
      {parentLabel && (
        <label className="checkbox-parent-label" style={{ color: mobileAccess ? "Black" : "Black" }}>
          {parentLabel}
        </label>
      )}
      <div className="checkbox-group div-space-adminrole">
        {options.map((option) => {
          const isViewPermissionForWebAccess = isWebAccess && option.name === "view_permission";
          
          return (
            <Controller
              key={`${name}.${option.name}`}
              name={`${name}.${option.name}`}
              control={control}
              defaultValue={isViewPermissionForWebAccess ? true : undefined}
              render={({ field: { onChange, value } }) => (
                <label
                  className="checkbox-container"
                  style={{ 
                    color: mobileAccess ? "Black" : "Black",
                    opacity: isViewPermissionForWebAccess ? 0.6 : 1
                  }}
                >
                  <span 
                    style={{ 
                      color: mobileAccess ? "Black" : "Black",
                      opacity: isViewPermissionForWebAccess ? 0.6 : 1
                    }} 
                    className="dynamic__checkbox--label label-adminrole"
                  >
                    {option.label}
                  </span>
                  <input
                    className="check-adminrole"
                    type="checkbox"
                    checked={isViewPermissionForWebAccess ? true : (value || false)}
                    onChange={(e) => {
                      if (!isViewPermissionForWebAccess) {
                        onChange(e.target.checked);
                      }
                    }}
                    // Use readOnly instead of disabled
                    readOnly={isViewPermissionForWebAccess}
                    style={{
                      cursor: isViewPermissionForWebAccess ? 'not-allowed' : 'pointer'
                    }}
                  />
                </label>
              )}
            />
          );
        })}
      </div>
    </div>
  );
};

export default CheckboxGroupWeb;
